import debounce from 'lodash/debounce';
import YTPlayer from '../../scripts/components/YTPlayer';
import { runSmartSubnav } from '../../snippets/smart-subnav/smart-subnav';
import { initPoeProduct } from '../../snippets/product-base-poe/product-base-poe';
import { setMaxHeightStyle } from '../../scripts/utils/setMaxHeightStyle';
import { initSmartHomeMobileSlider } from '../common/product-control-smart-home/product-control-smart-home';
import { initInstallationSlider } from '../../snippets/installation-slider/installation-slider';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';

runSmartSubnav({
  intersectionThreshold: [0, 0.2],
  intersectionRatio: 0.2,
});

const initCollapsiblePoeTechSpecsMenu = () => {
  const setMaxHeightToEls = () => {
    setMaxHeightStyle('[data-poe-tech-specs-collapsible-content]');
  };

  window.addEventListener('load', setMaxHeightToEls);

  window.addEventListener('resize', debounce(setMaxHeightToEls, 50));
};

initPoeProduct();
initSmartHomeMobileSlider();
initInstallationSlider();
YTPlayer.init();
initCollapsibleRows();
initCollapsiblePoeTechSpecsMenu();
